module.exports = __webpack_public_path__ + "img/123.827f01c1.jpeg";